import {
	Button,
	Checkbox,
	FormControlLabel,
	IconButton,
	Stack,
	Typography,
	useTheme,
} from '@mui/material';
import React from 'react';

import {SwipeableEdgeDrawer} from 'presentation/components';
import Icon from 'presentation/icons';
import {PrepareModalContent} from 'presentation/modules/myAppointments/ui/components/PrepareModalContent';
import {translations} from 'presentation/translations-new';

import {useExamOrientationsInfoStore} from '../../store/useExamOrientationsInfoStore';
import {ActionContainer, ContentContainer, StyledStack} from './styles';
import {ExamOrientationsDrawerProps} from './types';

const {keep} = translations['pt-br'].commons;
const {title, agreeCheckbox, headerTitle} =
	translations['pt-br'].privateFlow.bookingFlow.specialtyFlow.examOrientations;

export function ExamOrientationsDrawer({
	handleAgree,
	open,
	onToggleCheckbox,
	checked,
	onClose,
	dataTagIdInfo,
	dataTagIdButton,
}: ExamOrientationsDrawerProps) {
	const {palette} = useTheme();
	const examOrientationsInfo = useExamOrientationsInfoStore(state => state.examOrientationInfo);

	return (
		<SwipeableEdgeDrawer
			zIndex={1300}
			rounded
			customDrawerHeight={'auto'}
			open={open}
			setOpen={onClose}
			type="default">
			<ContentContainer data-tag-id={dataTagIdInfo}>
				<StyledStack>
					<Typography variant="h6">{headerTitle}</Typography>
					<IconButton onClick={onClose}>
						<Icon name="close-filled" color={palette.action.active} />
					</IconButton>
				</StyledStack>
				<Stack spacing={2}>
					<Typography variant="h6" color="primary">
						{title}
					</Typography>
					<PrepareModalContent
						examNumber={examOrientationsInfo.code}
						examName={examOrientationsInfo.examName}
					/>
				</Stack>
				<FormControlLabel
					control={<Checkbox checked={checked} onChange={onToggleCheckbox} />}
					label={agreeCheckbox}
				/>
			</ContentContainer>
			<ActionContainer>
				<Button
					fullWidth
					disabled={!checked}
					size="large"
					variant="contained"
					onClick={() => handleAgree(examOrientationsInfo)}
					data-tag-id={dataTagIdButton}>
					{keep}
				</Button>
			</ActionContainer>
		</SwipeableEdgeDrawer>
	);
}
